import { useMutation } from '@tanstack/react-query';
import { useNotification } from '../useNotification';
import { useFetchApi } from '../useFetchApi';
import { queryClient } from '../../testUtils';

export const useDeleteWebhook = () => {
  const fetch = useFetchApi();
  const { showErrorWithResponse } = useNotification();

  return useMutation({
    mutationFn: (id: string) =>
      fetch(`webhooks/${id}`, { method: 'DELETE' }) as Promise<{ ok: boolean }>,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['webhooks'] });
      return { ok: true };
    },
    onError: showErrorWithResponse,
  });
};
